import { Container, Row } from "reactstrap";
import { Popover, UIKits } from "../../../constants";
import BasicPopover from "./BasicPopover";
import PopoverDirection from "./PopoverDirection";
import PopoverOffset from "./popoverOffset";
import Breadcrumbs from "../../../coreComponents/breadcrumbs";

const PopoverContainer = () => {
  return (
    <>
      <Breadcrumbs mainTitle={Popover} parent={UIKits} />
      <Container fluid>
        <Row className="popover-main">
          <BasicPopover />
          <PopoverDirection />
          <PopoverOffset />
        </Row>
      </Container>
    </>
  );
};
export default PopoverContainer;
